import React, { useState } from "react";
import { getAuth, signOut } from "firebase/auth";
import { makeStyles } from "@material-ui/core/styles";
import { useNavigate, useLocation } from "react-router-dom";
import AddLinkIcon from "@mui/icons-material/AddLink";
import LinkIcon from "@mui/icons-material/Link";
import { Roles } from "../../Config/constants";
import { useTranslation } from "react-i18next";

import { Divider, Collapse, List, ListItem, ListItemIcon, ListItemText, IconButton, MenuItem, Drawer, Box } from "@mui/material";
import {
  Plus,
  House,
  Wrench,
  ListChecks,
  History,
  ChartColumnStacked,
  UserCog,
  Cog,
  ChevronDown,
  ChevronUp,
  ListPlus,
  List as ListIcon,
  X,
  LogOut as LogOutIcon,
  Users,
  HandCoins,
  ClipboardList,
  Database,
  CreditCard,
  ScanQrCode,
  Cpu,
} from "lucide-react";

function Menu(props) {
  const classes = useStyles();
  const navigate = useNavigate();
  const location = useLocation();
  const [openCollapse, setOpenCollapse] = useState(false);
  const { t } = useTranslation();

  function handleOpenSettings() {
    setOpenCollapse(!openCollapse);
  }
  const auth = getAuth();

  const LogOut = () => {
    signOut(auth)
      .then((response) => {
        navigate("/login");
        props.actions.setLogin(false);
        props.actions.setUserid(null);
        props.actions.setUserName(null);
        props.actions.setCompanyIds(null);
        props.actions.setUserRoles(null);
        props.actions.setSubscriberUniqueId(null);
        props.actions.setIsSubscriberAdmin(false);
        props.actions.setIsTaplrAdmin(false);
        props.actions.setAccessToken(null);
        props.actions.setEmail(null);

        // Sign-out successful.
      })
      .catch((error) => {
        console.log(error, "error");
        // An error happened.
      });
    // props.actions.setLogin(false);
    // props.actions.setUserid(null);
    // if (loggedInState === true) {
    //     navigate('/login');
    // }
  };

  const navigateTo = (destination) => {
    const currentPath = window.location.pathname;

    navigate(destination, { state: { from: currentPath } });
  };

  return (
    <div>
      <Drawer className={classes.sideBar} anchor={"right"} width={300} open={props.open} ModalProps={{ onBackdropClick: props.close }} sx={{}}>
        <Box sx={{ display: "flex", flexDirection: "column", height: "100%", justifyContent: "space-between" }}>
          <Box>
            <div className={classes.titleHeader}>
              <h2>{t('nav.menu')}</h2>
              <IconButton onClick={props.close} style={{ marginLeft: "120px", marginRight: "10px" }}>
                <X />
              </IconButton>
            </div>
            <Divider></Divider>
            <MenuItem selected={location.pathname === "/" ? true : false} className={classes.menuItem} onClick={() => navigateTo("/")} divider={true}>
              <span className={classes.iconItem}>
                <House />
              </span>
              <span className={classes.menuText}>{t('nav.homepage')}</span>
            </MenuItem>
            <MenuItem selected={location.pathname === "/create" ? true : false} className={classes.menuItem} onClick={() => navigateTo("/create")} divider={true}>
              <span className={classes.iconItem}>
                <Plus />
              </span>
              <span className={classes.menuText}>{t('nav.createProject')}</span>
            </MenuItem>
            {/* <MenuItem
                            selected={location.pathname === '/manage' ? true : false}
                            className={classes.menuItem}
                            onClick={() => navigateTo('/manage')}
                            divider={true}>
                            <span className={classes.iconItem}>
                                <Wrench ></Wrench >
                            </span>
                            <span className={classes.menuText}>Manage projects</span>
                        </MenuItem> */}
            <MenuItem selected={location.pathname === "/projectreportoverview" ? true : false} className={classes.menuItem} onClick={() => navigateTo("/projectreportoverview")} divider={true}>
              <span className={classes.iconItem}>
                <ListChecks />
              </span>
              <span className={classes.menuText}>{t('nav.projectOverview')}</span>
            </MenuItem>
            <MenuItem selected={location.pathname === "/results" ? true : false} className={classes.menuItem} onClick={() => navigateTo("/results")} divider={true}>
              <span className={classes.iconItem}>
                <History />
              </span>
              <span className={classes.menuText}>{t('nav.last24hours')}</span>
            </MenuItem>
            <MenuItem selected={location.pathname === "/graphs" ? true : false} className={classes.menuItem} onClick={() => navigateTo("/graphs")} divider={true}>
              <span className={classes.iconItem}>
                <ChartColumnStacked />
              </span>
              <span className={classes.menuText}>{t('nav.graphsOverview')}</span>
            </MenuItem>
            <MenuItem selected={location.pathname === "/datamanagement" ? true : false} className={classes.menuItem} onClick={() => navigateTo("/datamanagement")} divider={true}>
              <span className={classes.iconItem}>
                <Database />
              </span>
              <span className={classes.menuText}>{t('nav.dataManagement')}</span>
            </MenuItem>
            <MenuItem selected={location.pathname === "/financialcenter" ? true : false} className={classes.menuItem} onClick={() => navigateTo("/financialcenter")} divider={true}>
              <span className={classes.iconItem}>
                <HandCoins />
              </span>
              <span className={classes.menuText}>{t('nav.financialCenter')}</span>
            </MenuItem>
            <MenuItem selected={location.pathname === "/scanner" ? true : false} className={classes.menuItem} onClick={() => navigateTo("/scanner")} divider={true}>
              <span className={classes.iconItem}>
                <ScanQrCode />
              </span>
              <span className={classes.menuText}>{t('nav.scanner')}</span>
            </MenuItem>
            <MenuItem
              selected={
                location.pathname === "/dropdownoverview" ||
                location.pathname === "/createdropdown" ||
                location.pathname === "/flowboxoverview" ||
                location.pathname.startsWith("/flowboxdevice")
                  ? true
                  : false
              }
              className={classes.menuItem}
              onClick={handleOpenSettings}
              divider={true}
            >
              <span className={classes.iconItem}>
                <Cog />
              </span>
              <span className={classes.menuText}>{t('nav.configuration')}</span>
              {openCollapse ? <ChevronUp className={classes.toggleArrow} /> : <ChevronDown className={classes.toggleArrow} />}
            </MenuItem>
            <Collapse in={location.pathname === "/createdropdown" || location.pathname === "/flowboxoverview" || location.pathname.startsWith("/flowboxdevice") ? true : openCollapse} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <ListItem button className={classes.nested} selected={location.pathname === "/createdropdown" ? true : false} onClick={() => navigateTo("/createdropdown")} divider={true}>
                  <ListItemIcon className={classes.listItemIcon}>
                    <ListPlus />
                  </ListItemIcon>

                  <ListItemText className={classes.listItemText} primary={t('nav.createDropdown')} />
                </ListItem>
                <ListItem button className={classes.nested} selected={location.pathname === "/dropdownoverview" ? true : false} onClick={() => navigateTo("/dropdownoverview")} divider={true}>
                  <ListItemIcon className={classes.listItemIcon}>
                    <ListIcon />
                  </ListItemIcon>

                  <ListItemText className={classes.listItemText} primary={t('nav.dropdownOverview')} />
                </ListItem>

                <ListItem button className={classes.nested} selected={location.pathname === "/createapi" ? true : false} onClick={() => navigateTo("/createapi")} divider={true}>
                  <ListItemIcon className={classes.listItemIcon}>
                    <AddLinkIcon />
                  </ListItemIcon>

                  <ListItemText className={classes.listItemText} primary={t('nav.createApi')} />
                </ListItem>

                <ListItem button className={classes.nested} selected={location.pathname === "/externalapioverview" ? true : false} onClick={() => navigateTo("/externalapioverview")} divider={true}>
                  <ListItemIcon className={classes.listItemIcon}>
                    <LinkIcon />
                  </ListItemIcon>

                  <ListItemText className={classes.listItemText} primary={t('nav.apiOverview')} />
                </ListItem>

                <ListItem button className={classes.nested} selected={location.pathname === "/flowboxoverview" || location.pathname.startsWith("/flowboxdevice") ? true : false} onClick={() => navigateTo("/flowboxoverview")} divider={true}>
                  <ListItemIcon className={classes.listItemIcon}>
                    <Cpu />
                  </ListItemIcon>
                  <ListItemText className={classes.listItemText} primary="FlowBox devices" />
                </ListItem>
              </List>
            </Collapse>
          </Box>

          <List>
            <Divider></Divider>
            <MenuItem selected={location.pathname === "/user" ? true : false} className={classes.menuItem} onClick={() => navigateTo("/user")} divider={true}>
              <span className={classes.iconItem}>
                <UserCog />
              </span>
              <span className={classes.menuText}>{t('nav.userSettings')}</span>
            </MenuItem>
            <MenuItem selected={location.pathname === "/company" ? true : false} className={classes.menuItem} onClick={() => navigateTo("/company")} divider={true}>
              <span className={classes.iconItem}>
                <Users />
              </span>
              <span className={classes.menuText}>{t('nav.companySettings')}</span>
            </MenuItem>
            {props.Login.isTaplrAdmin && (
              <MenuItem selected={location.pathname === "/subscriptionmanagement" ? true : false} className={classes.menuItem} onClick={() => navigateTo("/subscriptionmanagement")} divider={true}>
                <span className={classes.iconItem}>
                  <CreditCard />
                </span>
                <span className={classes.menuText}>{t('nav.subscribers')}</span>
              </MenuItem>
            )}
            <MenuItem onClick={LogOut} style={{ color: "red" }} divider={true}>
              <span className={classes.iconItem}>
                <LogOutIcon />
              </span>
              <span className={classes.menuText}>{t('nav.logout')}</span>
            </MenuItem>
          </List>
        </Box>
      </Drawer>
    </div>
  );
}

export default Menu;
const useStyles = makeStyles({
  sideBar: {
    color: "#1D3557 !important",
    width: "300px",
    height: "100%",
  },
  titleHeader: {
    color: "#1D3557 !important",
    display: "flex",
    alignItems: "center",
    justifyContent: "around",
    marginLeft: "25px",
  },

  menuItem: {
    marginBottom: "15px",
    color: "rgb(105, 105, 105) !important",
    // borderTop: '1px solid grey',
  },
  menuText: {
    paddingTop: "10px",
    paddingBottom: "10px",
    marginLeft: "15px",
  },
  iconItem: {
    display: "flex",
    justifyContent: "center",
    width: "30px",
    paddingRight: "10px",
    borderRight: "1px solid rgba(0, 0, 0, 0.12)",
    fontSize: "25px !important",
  },
  ImgItem: {
    display: "flex",
    justifyContent: "center",
    width: "30px",
    paddingRight: "10px",
    borderRight: "1px solid rgba(0, 0, 0, 0.12)",
  },
  selectedItem: {
    backgroundColor: "red !important",
  },
  toggleArrow: {
    float: "right",
    marginRight: "0",
    marginLeft: "auto",
  },
  nested: {
    cursor: "pointer",
  },
  listItemIcon: {
    borderRight: "1px solid rgba(0, 0, 0, 0.12)",
    display: "flex",
    paddingRight: "10px",

    justifyContent: "end",
  },
  listItemText: {
    color: "rgb(105, 105, 105) !important",

    paddingLeft: "10px",
  },
  imageStyle: {
    filter: "contrast(80%)",
    opacity: "75%",
    width: "30px",
  },
});
